/* @ds-bundle: {"format":4,"namespace":"CoolbedsDesignSystem_8ea6cd","components":[{"name":"ClaimMarquee","sourcePath":"components/brand/ClaimMarquee.jsx"},{"name":"ClaimPill","sourcePath":"components/brand/ClaimPill.jsx"},{"name":"SatinBlock","sourcePath":"components/brand/SatinBlock.jsx"},{"name":"SwatchPicker","sourcePath":"components/brand/SwatchPicker.jsx"},{"name":"Wordmark","sourcePath":"components/brand/Wordmark.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Card","sourcePath":"components/core/Card.jsx"},{"name":"Icon","sourcePath":"components/core/Icon.jsx"},{"name":"Badge","sourcePath":"components/feedback/Badge.jsx"},{"name":"Tag","sourcePath":"components/feedback/Tag.jsx"},{"name":"Toast","sourcePath":"components/feedback/Toast.jsx"},{"name":"Tooltip","sourcePath":"components/feedback/Tooltip.jsx"},{"name":"Checkbox","sourcePath":"components/forms/Checkbox.jsx"},{"name":"Input","sourcePath":"components/forms/Input.jsx"},{"name":"QuantityStepper","sourcePath":"components/forms/QuantityStepper.jsx"},{"name":"Radio","sourcePath":"components/forms/Radio.jsx"},{"name":"Select","sourcePath":"components/forms/Select.jsx"},{"name":"Switch","sourcePath":"components/forms/Switch.jsx"},{"name":"Dialog","sourcePath":"components/navigation/Dialog.jsx"},{"name":"IconButton","sourcePath":"components/navigation/IconButton.jsx"},{"name":"Tabs","sourcePath":"components/navigation/Tabs.jsx"}],"sourceHashes":{"components/brand/ClaimMarquee.jsx":"1d6f73260091","components/brand/ClaimPill.jsx":"c4dd105cf8f7","components/brand/SatinBlock.jsx":"defaf2cce394","components/brand/SwatchPicker.jsx":"a328cf5eabc8","components/brand/Wordmark.jsx":"8d8a75bde388","components/core/Button.jsx":"8833bc1b8296","components/core/Card.jsx":"ba4e06de77a7","components/core/Icon.jsx":"18860599b818","components/feedback/Badge.jsx":"29c6cc7a811e","components/feedback/Tag.jsx":"93c8ae266a31","components/feedback/Toast.jsx":"be6bb9931aea","components/feedback/Tooltip.jsx":"98618d4b58cf","components/forms/Checkbox.jsx":"e70d00845ad8","components/forms/Input.jsx":"5e3e3203d3b6","components/forms/QuantityStepper.jsx":"9611f7d4870b","components/forms/Radio.jsx":"fcdf88476eb9","components/forms/Select.jsx":"53a43af3e6e1","components/forms/Switch.jsx":"a1c8e86719c9","components/navigation/Dialog.jsx":"fd1bce4e77dc","components/navigation/IconButton.jsx":"cbce99d10753","components/navigation/Tabs.jsx":"fd99c67cb367","ui_kits/storefront/App.jsx":"095fd586ee44","ui_kits/storefront/CheckoutScreen.jsx":"5ef8d3cf8efd","ui_kits/storefront/Chrome.jsx":"04f6024a7270","ui_kits/storefront/HomeScreen.jsx":"d58331b14b32","ui_kits/storefront/ProductScreen.jsx":"9116271e2b32","ui_kits/storefront/data.js":"51194d3a619c"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.CoolbedsDesignSystem_8ea6cd = window.CoolbedsDesignSystem_8ea6cd || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/brand/ClaimPill.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const tones = {
  ice: {
    background: 'var(--ice-100)',
    color: 'var(--slate-800)',
    border: '1px solid var(--border-hairline)'
  },
  outline: {
    background: 'transparent',
    color: 'var(--slate-800)',
    border: '1px solid var(--border-subtle)'
  },
  slate: {
    background: 'var(--slate-600)',
    color: '#fff',
    border: '1px solid transparent'
  },
  ink: {
    background: 'var(--slate-900)',
    color: '#fff',
    border: '1px solid transparent'
  },
  glacier: {
    background: 'var(--way-glacier)',
    color: 'var(--slate-900)',
    border: '1px solid transparent'
  },
  sheen: {
    background: 'var(--sheen-200)',
    color: 'var(--slate-900)',
    border: '1px solid transparent'
  },
  mist: {
    background: 'var(--way-mist)',
    color: 'var(--slate-900)',
    border: '1px solid transparent'
  }
};
function ClaimPill({
  tone = 'ice',
  size = 'md',
  children,
  style,
  ...rest
}) {
  const sizes = {
    sm: {
      fontSize: 'var(--fs-caption)',
      padding: '6px 14px'
    },
    md: {
      fontSize: 'var(--fs-body-s)',
      padding: '9px 18px'
    }
  };
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: 'var(--radius-pill)',
      fontFamily: 'var(--font-ui)',
      fontWeight: 600,
      whiteSpace: 'nowrap',
      ...sizes[size],
      ...tones[tone],
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { ClaimPill });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/brand/ClaimPill.jsx", error: String((e && e.message) || e) }); }

// components/brand/ClaimMarquee.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CYCLE = ['ice', 'slate', 'glacier', 'outline', 'ink', 'sheen', 'mist'];
function ClaimMarquee({
  claims = [],
  rows = 2,
  speed = 38,
  style,
  ...rest
}) {
  const id = React.useId().replace(/[^a-zA-Z0-9]/g, '');
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      overflow: 'hidden',
      padding: 'var(--space-5) 0',
      display: 'grid',
      gap: 'var(--space-3)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("style", null, `@keyframes cbm${id}{from{transform:translateX(0)}to{transform:translateX(-50%)}}@keyframes cbmr${id}{from{transform:translateX(-50%)}to{transform:translateX(0)}}`), Array.from({
    length: rows
  }).map((_, r) => /*#__PURE__*/React.createElement("div", {
    key: r,
    style: {
      display: 'flex',
      width: 'max-content',
      gap: 'var(--space-3)',
      animation: `${r % 2 ? 'cbmr' + id : 'cbm' + id} ${speed + r * 6}s linear infinite`
    }
  }, [0, 1].map(dup => claims.map((c, i) => /*#__PURE__*/React.createElement(__ds_scope.ClaimPill, {
    key: dup + '-' + i,
    tone: CYCLE[(i + r * 3) % CYCLE.length]
  }, c))))));
}
Object.assign(__ds_scope, { ClaimMarquee });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/brand/ClaimMarquee.jsx", error: String((e && e.message) || e) }); }

// components/brand/SatinBlock.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Stand-in for product photography. Coolbeds supplied no imagery — this renders a neutral
   satin-sheen gradient in a colorway so layouts read correctly. Replace with real photos. */
const WAYS = {
  pearl: ['#FBFAF6', '#EAE7DE'],
  glacier: ['#DDEAF1', '#A9C6D5'],
  slate: ['#6B8391', '#3D5462'],
  mist: ['#C3CBC7', '#98A5A0'],
  ink: ['#284452', '#0E2A38']
};
function SatinBlock({
  colorway = 'glacier',
  ratio = '4 / 3',
  label,
  angle = 115,
  radius = 'var(--radius-md)',
  style,
  children,
  ...rest
}) {
  const [a, b] = WAYS[colorway] || WAYS.glacier;
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      position: 'relative',
      aspectRatio: ratio,
      borderRadius: radius,
      overflow: 'hidden',
      background: `linear-gradient(${angle}deg,${a} 0%,${b} 55%,${a} 100%)`,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: 'var(--sheen-gradient)',
      opacity: .55,
      mixBlendMode: 'soft-light'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      background: `radial-gradient(120% 80% at 20% 10%,rgba(255,255,255,.35),transparent 60%)`
    }
  }), label && /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      left: 'var(--space-3)',
      bottom: 'var(--space-3)',
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--fs-micro)',
      letterSpacing: '.06em',
      textTransform: 'uppercase',
      color: 'rgba(255,255,255,.85)',
      background: 'rgba(14,42,56,.35)',
      padding: '4px 8px',
      borderRadius: 'var(--radius-sm)',
      backdropFilter: 'blur(4px)'
    }
  }, label), children);
}
Object.assign(__ds_scope, { SatinBlock });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/brand/SatinBlock.jsx", error: String((e && e.message) || e) }); }

// components/brand/SwatchPicker.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SwatchPicker({
  options = [],
  value,
  onChange,
  size = 34,
  showLabel = true,
  style,
  ...rest
}) {
  const active = value ?? options[0]?.id;
  const current = options.find(o => o.id === active);
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'grid',
      gap: 'var(--space-3)',
      ...style
    }
  }, rest), showLabel && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-2)',
      alignItems: 'baseline',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-caption)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      letterSpacing: 'var(--tracking-micro)',
      textTransform: 'uppercase',
      fontWeight: 600,
      color: 'var(--text-muted)'
    }
  }, "Colorway"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--text-heading)',
      fontWeight: 600
    }
  }, current?.name)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-2)'
    }
  }, options.map(o => {
    const on = o.id === active;
    return /*#__PURE__*/React.createElement("button", {
      key: o.id,
      onClick: () => onChange && onChange(o.id),
      title: o.name,
      "aria-label": o.name,
      style: {
        width: size,
        height: size,
        borderRadius: 'var(--radius-circle)',
        background: o.color,
        cursor: 'pointer',
        padding: 0,
        border: '1px solid var(--border-subtle)',
        boxShadow: on ? '0 0 0 2px var(--surface-page),0 0 0 3px var(--slate-900)' : 'none',
        transition: 'box-shadow var(--dur-fast) var(--ease-standard)'
      }
    });
  })));
}
Object.assign(__ds_scope, { SwatchPicker });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/brand/SwatchPicker.jsx", error: String((e && e.message) || e) }); }

// components/brand/Wordmark.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* No logo files were supplied with the brand. Per the design-system rules we do NOT draw a mark:
   the wordmark is the brand name set in the display face. See readme.md > ICONOGRAPHY. */
function Wordmark({
  size = 20,
  color = 'var(--slate-900)',
  boxed = false,
  style,
  ...rest
}) {
  const text = {
    fontFamily: 'var(--font-display)',
    fontWeight: 700,
    fontSize: size,
    letterSpacing: '-.015em',
    lineHeight: 1,
    color,
    whiteSpace: 'nowrap'
  };
  if (!boxed) return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      ...text,
      ...style
    }
  }, rest), "Coolbeds");
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: `${Math.round(size * .4)}px ${Math.round(size * .8)}px`,
      background: 'var(--surface-card)',
      border: '1px solid var(--border-subtle)',
      borderRadius: 'var(--radius-pill)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: text
  }, "Coolbeds"));
}
Object.assign(__ds_scope, { Wordmark });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/brand/Wordmark.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const base = {
  fontFamily: 'var(--font-ui)',
  fontWeight: 600,
  letterSpacing: '.01em',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'var(--space-2)',
  border: '1px solid transparent',
  borderRadius: 'var(--radius-pill)',
  cursor: 'pointer',
  transition: 'background var(--dur-fast) var(--ease-standard), color var(--dur-fast) var(--ease-standard), border-color var(--dur-fast) var(--ease-standard), transform var(--dur-instant) var(--ease-standard)',
  textDecoration: 'none',
  whiteSpace: 'nowrap'
};
const sizes = {
  sm: {
    fontSize: 'var(--fs-caption)',
    padding: '7px 14px'
  },
  md: {
    fontSize: 'var(--fs-body-s)',
    padding: '11px 20px'
  },
  lg: {
    fontSize: 'var(--fs-body)',
    padding: '15px 28px'
  }
};
const variants = {
  primary: {
    background: 'var(--accent)',
    color: 'var(--text-on-accent)'
  },
  secondary: {
    background: 'var(--surface-card)',
    color: 'var(--text-heading)',
    borderColor: 'var(--border-subtle)'
  },
  ghost: {
    background: 'transparent',
    color: 'var(--text-heading)'
  },
  inverse: {
    background: 'var(--surface-card)',
    color: 'var(--slate-900)'
  },
  quiet: {
    background: 'var(--ice-100)',
    color: 'var(--text-heading)'
  }
};
const hovers = {
  primary: {
    background: 'var(--accent-hover)'
  },
  secondary: {
    borderColor: 'var(--border-strong)'
  },
  ghost: {
    background: 'var(--ice-100)'
  },
  inverse: {
    background: 'var(--ice-100)'
  },
  quiet: {
    background: 'var(--ice-300)'
  }
};
function Button({
  variant = 'primary',
  size = 'md',
  disabled = false,
  fullWidth = false,
  iconLeft,
  iconRight,
  href,
  onClick,
  children,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const [press, setPress] = React.useState(false);
  const Tag = href ? 'a' : 'button';
  const s = {
    ...base,
    ...sizes[size],
    ...variants[variant],
    ...(hover && !disabled ? hovers[variant] : null),
    ...(press && !disabled ? {
      transform: 'scale(.975)'
    } : null),
    ...(fullWidth ? {
      width: '100%'
    } : null),
    ...(disabled ? {
      opacity: .38,
      cursor: 'not-allowed'
    } : null),
    ...style
  };
  return /*#__PURE__*/React.createElement(Tag, _extends({
    href: href,
    style: s,
    disabled: !href ? disabled : undefined,
    onClick: disabled ? undefined : onClick,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => {
      setHover(false);
      setPress(false);
    },
    onMouseDown: () => setPress(true),
    onMouseUp: () => setPress(false)
  }, rest), iconLeft, children, iconRight);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Card.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const tones = {
  plain: {
    background: 'var(--surface-card)',
    color: 'var(--text-body)'
  },
  ice: {
    background: 'var(--ice-100)',
    color: 'var(--text-body)'
  },
  slate: {
    background: 'var(--slate-600)',
    color: '#fff'
  },
  ink: {
    background: 'var(--slate-900)',
    color: 'var(--text-on-inverse)'
  },
  sheen: {
    background: 'var(--surface-sheen)',
    color: 'var(--slate-900)'
  }
};
function Card({
  tone = 'plain',
  padding = 'md',
  bordered = true,
  interactive = false,
  ratio,
  children,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const pads = {
    none: 0,
    sm: 'var(--space-4)',
    md: 'var(--space-5)',
    lg: 'var(--space-6)'
  };
  const s = {
    borderRadius: 'var(--radius-md)',
    padding: pads[padding],
    overflow: 'hidden',
    border: bordered && tone !== 'slate' && tone !== 'ink' ? '1px solid var(--border-hairline)' : '1px solid transparent',
    boxShadow: hover && interactive ? 'var(--shadow-md)' : 'var(--shadow-sm)',
    transform: hover && interactive ? 'translateY(-2px)' : 'none',
    transition: 'box-shadow var(--dur-base) var(--ease-standard), transform var(--dur-base) var(--ease-standard)',
    ...(ratio ? {
      aspectRatio: ratio
    } : null),
    ...tones[tone],
    ...style
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    style: s,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, rest), children);
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Card.jsx", error: String((e && e.message) || e) }); }

// components/core/Icon.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Lucide, loaded from CDN. See readme.md > ICONOGRAPHY — this is a flagged substitution:
   no icon set was supplied with the brand. */
function Icon({
  name,
  size = 20,
  stroke = 1.75,
  color = 'currentColor',
  style,
  ...rest
}) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const draw = () => {
      const L = window.lucide;
      if (!L || !ref.current) return;
      const key = name.replace(/(^|-)([a-z])/g, (_, d, c) => c.toUpperCase());
      const node = L.icons && (L.icons[key] || L.icons[name]) || null;
      if (!node) return;
      ref.current.innerHTML = '';
      const el = L.createElement(node);
      el.setAttribute('width', size);
      el.setAttribute('height', size);
      el.setAttribute('stroke-width', stroke);
      el.setAttribute('stroke', color);
      ref.current.appendChild(el);
    };
    draw();
    if (!window.lucide) {
      const id = 'cb-lucide';
      let s = document.getElementById(id);
      if (!s) {
        s = document.createElement('script');
        s.id = id;
        s.src = 'https://unpkg.com/lucide@0.454.0/dist/umd/lucide.min.js';
        document.head.appendChild(s);
      }
      s.addEventListener('load', draw);
    }
  }, [name, size, stroke, color]);
  return /*#__PURE__*/React.createElement("span", _extends({
    ref: ref,
    "aria-hidden": "true",
    style: {
      display: 'inline-flex',
      width: size,
      height: size,
      flex: '0 0 auto',
      ...style
    }
  }, rest));
}
Object.assign(__ds_scope, { Icon });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Icon.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Badge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const tones = {
  neutral: {
    background: 'var(--ice-100)',
    color: 'var(--slate-700)'
  },
  accent: {
    background: 'var(--accent)',
    color: '#fff'
  },
  success: {
    background: 'var(--status-success-wash)',
    color: 'var(--status-success)'
  },
  warning: {
    background: 'var(--status-warning-wash)',
    color: 'var(--status-warning)'
  },
  danger: {
    background: 'var(--status-danger-wash)',
    color: 'var(--status-danger)'
  },
  ink: {
    background: 'var(--slate-900)',
    color: '#fff'
  }
};
function Badge({
  tone = 'neutral',
  children,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '4px 9px',
      borderRadius: 'var(--radius-sm)',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-micro)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-label)',
      textTransform: 'uppercase',
      ...tones[tone],
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Badge.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Tag.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Tag({
  children,
  onRemove,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 'var(--space-2)',
      padding: '5px 10px',
      borderRadius: 'var(--radius-sm)',
      background: 'var(--surface-card)',
      border: '1px solid var(--border-subtle)',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-body)',
      ...style
    }
  }, rest), children, onRemove && /*#__PURE__*/React.createElement("button", {
    onClick: onRemove,
    "aria-label": "Remove",
    style: {
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
      color: 'var(--text-muted)',
      padding: 0,
      fontSize: 13,
      lineHeight: 1
    }
  }, "\xD7"));
}
Object.assign(__ds_scope, { Tag });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Tag.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Toast.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const tones = {
  neutral: {
    background: 'var(--slate-900)',
    color: '#fff'
  },
  success: {
    background: 'var(--status-success)',
    color: '#fff'
  },
  danger: {
    background: 'var(--status-danger)',
    color: '#fff'
  }
};
function Toast({
  tone = 'neutral',
  title,
  message,
  action,
  onDismiss,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "status",
    style: {
      display: 'flex',
      gap: 'var(--space-4)',
      alignItems: 'center',
      padding: '14px 18px',
      borderRadius: 'var(--radius-md)',
      boxShadow: 'var(--shadow-lg)',
      fontFamily: 'var(--font-ui)',
      maxWidth: 420,
      ...tones[tone],
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gap: 2,
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-body-s)',
      fontWeight: 600
    }
  }, title), message && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      opacity: .8
    }
  }, message)), action, onDismiss && /*#__PURE__*/React.createElement("button", {
    onClick: onDismiss,
    "aria-label": "Dismiss",
    style: {
      border: 'none',
      background: 'transparent',
      color: 'inherit',
      opacity: .7,
      cursor: 'pointer',
      fontSize: 16,
      lineHeight: 1,
      padding: 0
    }
  }, "\xD7"));
}
Object.assign(__ds_scope, { Toast });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Toast.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Tooltip.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Tooltip({
  content,
  placement = 'top',
  children,
  style,
  ...rest
}) {
  const [open, setOpen] = React.useState(false);
  const pos = placement === 'bottom' ? {
    top: 'calc(100% + 8px)',
    left: '50%',
    transform: 'translateX(-50%)'
  } : {
    bottom: 'calc(100% + 8px)',
    left: '50%',
    transform: 'translateX(-50%)'
  };
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      position: 'relative',
      display: 'inline-flex',
      ...style
    },
    onMouseEnter: () => setOpen(true),
    onMouseLeave: () => setOpen(false),
    onFocus: () => setOpen(true),
    onBlur: () => setOpen(false)
  }, rest), children, open && /*#__PURE__*/React.createElement("span", {
    role: "tooltip",
    style: {
      position: 'absolute',
      ...pos,
      zIndex: 40,
      background: 'var(--slate-900)',
      color: '#fff',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-caption)',
      padding: '7px 10px',
      borderRadius: 'var(--radius-sm)',
      whiteSpace: 'nowrap',
      boxShadow: 'var(--shadow-md)'
    }
  }, content));
}
Object.assign(__ds_scope, { Tooltip });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Tooltip.jsx", error: String((e && e.message) || e) }); }

// components/forms/Checkbox.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Checkbox({
  label,
  description,
  checked,
  onChange,
  disabled,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: 'flex',
      gap: 'var(--space-3)',
      alignItems: 'flex-start',
      fontFamily: 'var(--font-ui)',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? .45 : 1,
      ...style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      flex: '0 0 auto',
      width: 18,
      height: 18,
      marginTop: 2,
      borderRadius: 'var(--radius-xs)',
      background: checked ? 'var(--accent)' : 'var(--surface-card)',
      border: '1px solid ' + (checked ? 'var(--accent)' : 'var(--border-strong)'),
      transition: 'background var(--dur-fast) var(--ease-standard), border-color var(--dur-fast) var(--ease-standard)'
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    checked: !!checked,
    disabled: disabled,
    onChange: e => onChange && onChange(e.target.checked),
    style: {
      position: 'absolute',
      opacity: 0,
      inset: 0,
      margin: 0,
      cursor: 'inherit'
    }
  }, rest)), checked && /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16",
    width: "16",
    height: "16",
    style: {
      position: 'absolute',
      inset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.5l3 3 6-7",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gap: 2
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-body-s)',
      color: 'var(--text-heading)',
      fontWeight: 500
    }
  }, label), description && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, description)));
}
Object.assign(__ds_scope, { Checkbox });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Checkbox.jsx", error: String((e && e.message) || e) }); }

// components/forms/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Input({
  label,
  hint,
  error,
  size = 'md',
  prefix,
  suffix,
  type = 'text',
  style,
  wrapperStyle,
  ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  const pads = {
    md: '11px 14px',
    lg: '15px 16px'
  };
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: 'grid',
      gap: 'var(--space-2)',
      fontFamily: 'var(--font-ui)',
      ...wrapperStyle
    }
  }, label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      fontWeight: 600,
      color: 'var(--text-heading)'
    }
  }, label), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--space-2)',
      background: 'var(--surface-card)',
      border: '1px solid ' + (error ? 'var(--status-danger)' : focus ? 'var(--border-focus)' : 'var(--border-subtle)'),
      borderRadius: 'var(--radius-md)',
      padding: pads[size],
      boxShadow: focus ? '0 0 0 3px rgba(74,107,124,.14)' : 'none',
      transition: 'border-color var(--dur-fast) var(--ease-standard), box-shadow var(--dur-fast) var(--ease-standard)'
    }
  }, prefix && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--text-muted)',
      display: 'flex'
    }
  }, prefix), /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    style: {
      border: 'none',
      outline: 'none',
      background: 'transparent',
      font: 'var(--type-body)',
      fontSize: 'var(--fs-body-s)',
      color: 'var(--text-body)',
      width: '100%',
      ...style
    }
  }, rest)), suffix && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--text-muted)',
      display: 'flex'
    }
  }, suffix)), (hint || error) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: error ? 'var(--status-danger)' : 'var(--text-muted)'
    }
  }, error || hint));
}
Object.assign(__ds_scope, { Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Input.jsx", error: String((e && e.message) || e) }); }

// components/forms/QuantityStepper.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function QuantityStepper({
  value = 1,
  min = 1,
  max = 99,
  onChange,
  size = 'md',
  style,
  ...rest
}) {
  const set = v => onChange && onChange(Math.min(max, Math.max(min, v)));
  const dim = size === 'sm' ? 28 : 36;
  const btn = {
    width: dim,
    height: dim,
    display: 'grid',
    placeItems: 'center',
    border: 'none',
    background: 'transparent',
    color: 'var(--text-heading)',
    cursor: 'pointer',
    fontFamily: 'var(--font-ui)',
    fontSize: 16,
    lineHeight: 1
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      border: '1px solid var(--border-subtle)',
      borderRadius: 'var(--radius-pill)',
      background: 'var(--surface-card)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("button", {
    style: btn,
    onClick: () => set(value - 1),
    "aria-label": "Decrease"
  }, "\u2013"), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 24,
      textAlign: 'center',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-body-s)',
      fontWeight: 600,
      color: 'var(--text-heading)'
    }
  }, value), /*#__PURE__*/React.createElement("button", {
    style: btn,
    onClick: () => set(value + 1),
    "aria-label": "Increase"
  }, "+"));
}
Object.assign(__ds_scope, { QuantityStepper });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/QuantityStepper.jsx", error: String((e && e.message) || e) }); }

// components/forms/Radio.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Radio({
  label,
  description,
  checked,
  onChange,
  name,
  disabled,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: 'flex',
      gap: 'var(--space-3)',
      alignItems: 'flex-start',
      fontFamily: 'var(--font-ui)',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? .45 : 1,
      ...style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      flex: '0 0 auto',
      width: 18,
      height: 18,
      marginTop: 2,
      borderRadius: '50%',
      background: 'var(--surface-card)',
      border: '1px solid ' + (checked ? 'var(--accent)' : 'var(--border-strong)'),
      display: 'grid',
      placeItems: 'center',
      transition: 'border-color var(--dur-fast) var(--ease-standard)'
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    name: name,
    checked: !!checked,
    disabled: disabled,
    onChange: () => onChange && onChange(true),
    style: {
      position: 'absolute',
      opacity: 0,
      inset: 0,
      margin: 0,
      cursor: 'inherit'
    }
  }, rest)), checked && /*#__PURE__*/React.createElement("span", {
    style: {
      width: 9,
      height: 9,
      borderRadius: '50%',
      background: 'var(--accent)'
    }
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gap: 2
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-body-s)',
      color: 'var(--text-heading)',
      fontWeight: 500
    }
  }, label), description && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, description)));
}
Object.assign(__ds_scope, { Radio });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Radio.jsx", error: String((e && e.message) || e) }); }

// components/forms/Select.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Select({
  label,
  hint,
  options = [],
  size = 'md',
  style,
  wrapperStyle,
  ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  const pads = {
    md: '11px 14px',
    lg: '15px 16px'
  };
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: 'grid',
      gap: 'var(--space-2)',
      fontFamily: 'var(--font-ui)',
      ...wrapperStyle
    }
  }, label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      fontWeight: 600,
      color: 'var(--text-heading)'
    }
  }, label), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("select", _extends({
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    style: {
      width: '100%',
      appearance: 'none',
      background: 'var(--surface-card)',
      color: 'var(--text-body)',
      border: '1px solid ' + (focus ? 'var(--border-focus)' : 'var(--border-subtle)'),
      borderRadius: 'var(--radius-md)',
      padding: pads[size],
      paddingRight: 38,
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-body-s)',
      cursor: 'pointer',
      boxShadow: focus ? '0 0 0 3px rgba(74,107,124,.14)' : 'none',
      outline: 'none'
    }
  }, rest), options.map(o => /*#__PURE__*/React.createElement("option", {
    key: o.value ?? o,
    value: o.value ?? o
  }, o.label ?? o))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      right: 14,
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
      color: 'var(--text-muted)',
      fontSize: 10
    }
  }, "\u25BE")), hint && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, hint));
}
Object.assign(__ds_scope, { Select });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Select.jsx", error: String((e && e.message) || e) }); }

// components/forms/Switch.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Switch({
  label,
  checked,
  onChange,
  disabled,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: 'inline-flex',
      gap: 'var(--space-3)',
      alignItems: 'center',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-body-s)',
      color: 'var(--text-heading)',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? .45 : 1,
      ...style
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'relative',
      width: 40,
      height: 23,
      borderRadius: 'var(--radius-pill)',
      flex: '0 0 auto',
      background: checked ? 'var(--accent)' : 'var(--ice-400)',
      transition: 'background var(--dur-base) var(--ease-standard)'
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    checked: !!checked,
    disabled: disabled,
    onChange: e => onChange && onChange(e.target.checked),
    style: {
      position: 'absolute',
      opacity: 0,
      inset: 0,
      margin: 0,
      cursor: 'inherit'
    }
  }, rest)), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 3,
      left: checked ? 20 : 3,
      width: 17,
      height: 17,
      borderRadius: '50%',
      background: '#fff',
      boxShadow: 'var(--shadow-sm)',
      transition: 'left var(--dur-base) var(--ease-out)'
    }
  })), label);
}
Object.assign(__ds_scope, { Switch });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Switch.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Dialog.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Dialog({
  open,
  title,
  onClose,
  footer,
  width = 480,
  children,
  style,
  ...rest
}) {
  if (!open) return null;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      inset: 0,
      zIndex: 60,
      display: 'grid',
      placeItems: 'center',
      padding: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: 'absolute',
      inset: 0,
      background: 'rgba(14,42,56,.42)',
      backdropFilter: 'blur(3px)'
    }
  }), /*#__PURE__*/React.createElement("div", _extends({
    role: "dialog",
    "aria-modal": "true",
    style: {
      position: 'relative',
      width: '100%',
      maxWidth: width,
      background: 'var(--surface-card)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-lg)',
      overflow: 'hidden',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 'var(--space-4)',
      padding: 'var(--space-5)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 'var(--fs-display-s)',
      fontWeight: 700
    }
  }, title), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Close",
    style: {
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
      color: 'var(--text-muted)',
      fontSize: 20,
      lineHeight: 1,
      padding: 0
    }
  }, "\xD7")), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-5)',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-body-s)',
      lineHeight: 'var(--lh-body)'
    }
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 'var(--space-3)',
      padding: 'var(--space-5)',
      borderTop: '1px solid var(--border-hairline)',
      background: 'var(--ice-50)'
    }
  }, footer)));
}
Object.assign(__ds_scope, { Dialog });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Dialog.jsx", error: String((e && e.message) || e) }); }

// components/navigation/IconButton.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function IconButton({
  label,
  size = 'md',
  variant = 'secondary',
  children,
  onClick,
  style,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const dims = {
    sm: 32,
    md: 40,
    lg: 46
  };
  const variants = {
    secondary: {
      background: 'var(--surface-card)',
      border: '1px solid var(--border-subtle)',
      color: 'var(--text-heading)'
    },
    ghost: {
      background: hover ? 'var(--ice-100)' : 'transparent',
      border: '1px solid transparent',
      color: 'var(--text-heading)'
    },
    accent: {
      background: hover ? 'var(--accent-hover)' : 'var(--accent)',
      border: '1px solid transparent',
      color: '#fff'
    },
    inverse: {
      background: 'rgba(255,255,255,.16)',
      border: '1px solid rgba(255,255,255,.28)',
      color: '#fff',
      backdropFilter: 'blur(6px)'
    }
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    "aria-label": label,
    onClick: onClick,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      width: dims[size],
      height: dims[size],
      borderRadius: 'var(--radius-circle)',
      display: 'grid',
      placeItems: 'center',
      cursor: 'pointer',
      padding: 0,
      transition: 'background var(--dur-fast) var(--ease-standard), border-color var(--dur-fast) var(--ease-standard)',
      ...variants[variant],
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { IconButton });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/IconButton.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Tabs.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Tabs({
  tabs = [],
  value,
  onChange,
  style,
  ...rest
}) {
  const active = value ?? tabs[0]?.id;
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tablist",
    style: {
      display: 'flex',
      gap: 'var(--space-5)',
      borderBottom: '1px solid var(--border-hairline)',
      ...style
    }
  }, rest), tabs.map(t => {
    const on = t.id === active;
    return /*#__PURE__*/React.createElement("button", {
      key: t.id,
      role: "tab",
      "aria-selected": on,
      onClick: () => onChange && onChange(t.id),
      style: {
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        padding: '0 0 12px',
        fontFamily: 'var(--font-ui)',
        fontSize: 'var(--fs-body-s)',
        fontWeight: on ? 600 : 500,
        color: on ? 'var(--text-heading)' : 'var(--text-muted)',
        boxShadow: on ? 'inset 0 -2px 0 var(--slate-900)' : 'none',
        transition: 'color var(--dur-fast) var(--ease-standard)'
      }
    }, t.label);
  }));
}
Object.assign(__ds_scope, { Tabs });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Tabs.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/App.jsx
try { (() => {
const {
  Toast,
  Button
} = window.CoolbedsDesignSystem_8ea6cd;
function App() {
  const data = window.CB_DATA;
  const [screen, setScreen] = React.useState('home');
  const [colorway, setColorway] = React.useState('glacier');
  const [items, setItems] = React.useState([]);
  const [toast, setToast] = React.useState(null);
  const nav = (s, way) => {
    if (way) setColorway(way);
    setScreen(s);
    window.scrollTo(0, 0);
  };
  const add = it => {
    setItems(prev => [...prev, it]);
    const name = data.colorways.find(c => c.id === it.colorway)?.name;
    setToast({
      title: 'Added to bag',
      message: name + ' · ' + it.size
    });
    setTimeout(() => setToast(null), 3200);
  };
  const count = items.reduce((n, i) => n + i.qty, 0);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(Nav, {
    onNav: nav,
    cartCount: count,
    onCart: () => nav('cart')
  }), /*#__PURE__*/React.createElement("main", {
    style: {
      flex: 1
    }
  }, screen === 'home' && /*#__PURE__*/React.createElement(HomeScreen, {
    data: data,
    onNav: nav
  }), screen === 'pdp' && /*#__PURE__*/React.createElement(ProductScreen, {
    data: data,
    colorway: colorway,
    setColorway: setColorway,
    onAdd: add
  }), screen === 'cart' && /*#__PURE__*/React.createElement(CartScreen, {
    data: data,
    items: items,
    setItems: setItems,
    onNav: nav
  }), screen === 'checkout' && /*#__PURE__*/React.createElement(CheckoutScreen, {
    data: data,
    items: items,
    onNav: nav
  }), screen === 'confirm' && /*#__PURE__*/React.createElement(ConfirmScreen, {
    onNav: nav
  })), screen !== 'confirm' && /*#__PURE__*/React.createElement(Footer, {
    onNav: nav
  }), toast && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      left: 24,
      bottom: 24,
      zIndex: 70
    }
  }, /*#__PURE__*/React.createElement(Toast, {
    tone: "success",
    title: toast.title,
    message: toast.message,
    onDismiss: () => setToast(null),
    action: /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      variant: "inverse",
      onClick: () => {
        setToast(null);
        nav('cart');
      }
    }, "View bag")
  })));
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(App, null));
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/App.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/CheckoutScreen.jsx
try { (() => {
const {
  Button,
  Card,
  Icon,
  Input,
  Select,
  Radio,
  Checkbox,
  QuantityStepper,
  Badge,
  SatinBlock,
  Wordmark
} = window.CoolbedsDesignSystem_8ea6cd;
function LineItem({
  item,
  onQty,
  onRemove,
  data
}) {
  const way = data.colorways.find(c => c.id === item.colorway);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '84px 1fr auto',
      gap: 'var(--space-4)',
      alignItems: 'center',
      padding: 'var(--space-4) 0',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, /*#__PURE__*/React.createElement(SatinBlock, {
    colorway: item.colorway,
    ratio: "1 / 1"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 6
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-body-s)',
      fontWeight: 600,
      color: 'var(--text-heading)'
    }
  }, data.product.name), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, way?.name, " \xB7 ", item.size), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-3)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(QuantityStepper, {
    size: "sm",
    value: item.qty,
    onChange: onQty
  }), /*#__PURE__*/React.createElement("button", {
    onClick: onRemove,
    style: {
      border: 'none',
      background: 'transparent',
      padding: 0,
      cursor: 'pointer',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)',
      textDecoration: 'underline',
      textUnderlineOffset: 3
    }
  }, "Remove"))), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--fs-body-s)',
      color: 'var(--text-heading)'
    }
  }, "\xA3", item.price * item.qty));
}
function Summary({
  items,
  ship,
  children
}) {
  const sub = items.reduce((n, i) => n + i.price * i.qty, 0);
  const shipCost = sub > 120 || ship === 'std' ? 0 : 8;
  const total = sub + (ship === 'exp' ? 8 : shipCost);
  const row = (a, b, strong) => /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'var(--font-ui)',
      fontSize: strong ? 'var(--fs-body)' : 'var(--fs-body-s)',
      fontWeight: strong ? 700 : 400,
      color: strong ? 'var(--text-heading)' : 'var(--text-body)'
    }
  }, /*#__PURE__*/React.createElement("span", null, a), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)'
    }
  }, b));
  return /*#__PURE__*/React.createElement(Card, {
    padding: "md",
    style: {
      display: 'grid',
      gap: 'var(--space-3)',
      position: 'sticky',
      top: 88
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-micro)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-micro)',
      textTransform: 'uppercase',
      color: 'var(--text-muted)'
    }
  }, "Summary"), row('Subtotal', '£' + sub), row('Shipping', ship === 'exp' ? '£8' : 'Free'), row('Tax', 'At next step'), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 1,
      background: 'var(--border-hairline)',
      margin: '4px 0'
    }
  }), row('Total', '£' + total, true), children);
}
function CartScreen({
  data,
  items,
  setItems,
  onNav
}) {
  if (!items.length) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: 520,
        margin: '0 auto',
        padding: 'var(--space-9) var(--space-5)',
        display: 'grid',
        gap: 'var(--space-5)',
        justifyItems: 'center',
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "shopping-bag",
      size: 30,
      color: "var(--text-faint)"
    }), /*#__PURE__*/React.createElement("h1", {
      style: {
        font: 'var(--type-display-section)',
        fontSize: 'var(--fs-display-m)',
        margin: 0
      }
    }, "Your bag is empty"), /*#__PURE__*/React.createElement(Button, {
      size: "lg",
      onClick: () => onNav('pdp')
    }, "Shop the set"));
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-7) var(--space-5) var(--space-9)',
      display: 'grid',
      gridTemplateColumns: '1.6fr 1fr',
      gap: 'var(--space-7)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    style: {
      font: 'var(--type-display-section)',
      fontSize: 'var(--fs-display-m)',
      margin: '0 0 var(--space-4)'
    }
  }, "Your bag"), items.map((it, i) => /*#__PURE__*/React.createElement(LineItem, {
    key: i,
    item: it,
    data: data,
    onQty: q => setItems(items.map((x, j) => j === i ? {
      ...x,
      qty: q
    } : x)),
    onRemove: () => setItems(items.filter((_, j) => j !== i))
  }))), /*#__PURE__*/React.createElement(Summary, {
    items: items,
    ship: "std"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    fullWidth: true,
    onClick: () => onNav('checkout')
  }, "Checkout"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)',
      textAlign: 'center'
    }
  }, "Free returns within 30 nights.")));
}
function CheckoutScreen({
  data,
  items,
  onNav
}) {
  const [ship, setShip] = React.useState('std');
  const [pay, setPay] = React.useState('card');
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-7) var(--space-5) var(--space-9)',
      display: 'grid',
      gridTemplateColumns: '1.6fr 1fr',
      gap: 'var(--space-7)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      font: 'var(--type-display-section)',
      fontSize: 'var(--fs-display-m)',
      margin: 0
    }
  }, "Checkout"), /*#__PURE__*/React.createElement("section", {
    style: {
      display: 'grid',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-micro)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-micro)',
      textTransform: 'uppercase',
      color: 'var(--text-muted)'
    }
  }, "Contact"), /*#__PURE__*/React.createElement(Input, {
    label: "Email",
    size: "lg",
    placeholder: "you@example.com"
  })), /*#__PURE__*/React.createElement("section", {
    style: {
      display: 'grid',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-micro)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-micro)',
      textTransform: 'uppercase',
      color: 'var(--text-muted)'
    }
  }, "Delivery"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    label: "First name",
    size: "lg"
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Last name",
    size: "lg"
  })), /*#__PURE__*/React.createElement(Input, {
    label: "Address",
    size: "lg"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    label: "City",
    size: "lg"
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Postcode",
    size: "lg"
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Country",
    size: "lg",
    options: ['United Kingdom', 'Ireland', 'France', 'Germany']
  }))), /*#__PURE__*/React.createElement("section", {
    style: {
      display: 'grid',
      gap: 'var(--space-3)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-micro)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-micro)',
      textTransform: 'uppercase',
      color: 'var(--text-muted)'
    }
  }, "Shipping method"), [['std', 'Standard', '4–6 nights · Free'], ['exp', 'Express', '2 nights · £8']].map(([id, t, d]) => /*#__PURE__*/React.createElement(Card, {
    key: id,
    padding: "sm",
    style: {
      borderColor: ship === id ? 'var(--accent)' : 'var(--border-hairline)',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Radio, {
    name: "ship",
    label: t,
    description: d,
    checked: ship === id,
    onChange: () => setShip(id)
  })))), /*#__PURE__*/React.createElement("section", {
    style: {
      display: 'grid',
      gap: 'var(--space-3)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-micro)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-micro)',
      textTransform: 'uppercase',
      color: 'var(--text-muted)'
    }
  }, "Payment"), [['card', 'Card', 'Visa, Mastercard, Amex'], ['later', 'Pay in 3', 'No interest']].map(([id, t, d]) => /*#__PURE__*/React.createElement(Card, {
    key: id,
    padding: "sm",
    style: {
      borderColor: pay === id ? 'var(--accent)' : 'var(--border-hairline)'
    }
  }, /*#__PURE__*/React.createElement(Radio, {
    name: "pay",
    label: t,
    description: d,
    checked: pay === id,
    onChange: () => setPay(id)
  }))), pay === 'card' && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Card number",
    size: "lg",
    placeholder: "0000 0000 0000 0000",
    suffix: /*#__PURE__*/React.createElement(Icon, {
      name: "credit-card",
      size: 16
    })
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Expiry",
    size: "lg",
    placeholder: "MM / YY"
  }), /*#__PURE__*/React.createElement(Input, {
    label: "CVC",
    size: "lg",
    placeholder: "123"
  })), /*#__PURE__*/React.createElement(Checkbox, {
    label: "Save my details for next time",
    checked: false
  }))), /*#__PURE__*/React.createElement(Summary, {
    items: items,
    ship: ship
  }, /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    fullWidth: true,
    onClick: () => onNav('confirm')
  }, "Pay now"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)',
      textAlign: 'center'
    }
  }, "This is a prototype. No payment is taken.")));
}
function ConfirmScreen({
  onNav
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 560,
      margin: '0 auto',
      padding: 'var(--space-9) var(--space-5)',
      display: 'grid',
      gap: 'var(--space-5)',
      justifyItems: 'center',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    tone: "success"
  }, "Order placed"), /*#__PURE__*/React.createElement("h1", {
    style: {
      font: 'var(--type-display-section)',
      margin: 0
    }
  }, "Sleep well"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--fs-body-l)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-body)'
    }
  }, "Your set is on its way. We will email tracking within a day."), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, "Order CB-48210"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: () => onNav('home')
  }, "Back to Coolbeds"));
}
Object.assign(window, {
  CartScreen,
  CheckoutScreen,
  ConfirmScreen
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/CheckoutScreen.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/Chrome.jsx
try { (() => {
const {
  Wordmark,
  Button,
  IconButton,
  Icon
} = window.CoolbedsDesignSystem_8ea6cd;
function Nav({
  onNav,
  cartCount,
  onCart
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'sticky',
      top: 0,
      zIndex: 50,
      padding: 'var(--space-4) var(--space-5)',
      display: 'flex',
      justifyContent: 'center',
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      pointerEvents: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--space-5)',
      width: '100%',
      maxWidth: 'var(--container)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-2)'
    }
  }, ['instagram', 'facebook', 'youtube'].map(n => /*#__PURE__*/React.createElement(IconButton, {
    key: n,
    label: n,
    variant: "secondary",
    size: "sm"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: n,
    size: 15
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => onNav('home'),
    style: {
      border: 'none',
      padding: 0,
      background: 'transparent',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Wordmark, {
    size: 19,
    boxed: true
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-2)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary",
    onClick: () => onNav('pdp')
  }, "Our sheets"), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary",
    onClick: () => onNav('home')
  }, "Our story"), /*#__PURE__*/React.createElement(IconButton, {
    label: "Bag",
    variant: "secondary",
    size: "sm",
    onClick: onCart,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "shopping-bag",
    size: 15
  }), cartCount > 0 && /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: -3,
      right: -3,
      minWidth: 16,
      height: 16,
      borderRadius: 999,
      background: 'var(--slate-900)',
      color: '#fff',
      fontSize: 10,
      fontWeight: 700,
      display: 'grid',
      placeItems: 'center',
      padding: '0 4px'
    }
  }, cartCount)))));
}
function Footer({
  onNav
}) {
  const cols = [['Shop', ['The Cool Satin Set', 'Pillowcases', 'Duvet cover', 'Gift cards']], ['Help', ['Shipping', 'Returns', 'Care guide', 'Contact']], ['Coolbeds', ['Our story', 'The weave', 'Certifications', 'Reviews']]];
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      background: 'var(--surface-inverse)',
      color: 'var(--text-on-inverse)',
      padding: 'var(--space-9) var(--space-5) var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1.4fr repeat(3,1fr)',
      gap: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-4)',
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement(Wordmark, {
    size: 26,
    color: "#fff"
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--fs-body-s)',
      lineHeight: 'var(--lh-body)',
      opacity: .7,
      maxWidth: '28ch'
    }
  }, "Satin that stays cool. Made in Portugal, shipped from London.")), cols.map(([h, items]) => /*#__PURE__*/React.createElement("div", {
    key: h,
    style: {
      display: 'grid',
      gap: 'var(--space-3)',
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-micro)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-micro)',
      textTransform: 'uppercase',
      opacity: .55
    }
  }, h), items.map(i => /*#__PURE__*/React.createElement("a", {
    key: i,
    href: "#",
    onClick: e => {
      e.preventDefault();
      onNav && onNav('pdp');
    },
    style: {
      color: 'inherit',
      textDecoration: 'none',
      fontSize: 'var(--fs-body-s)',
      opacity: .85
    }
  }, i))))), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      marginTop: 'var(--space-8)',
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid rgba(255,255,255,.14)',
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 'var(--fs-caption)',
      opacity: .5
    }
  }, /*#__PURE__*/React.createElement("span", null, "\xA9 2026 Coolbeds"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)'
    }
  }, "OEKO-TEX 100 \xB7 24.HPT.12345")));
}
Object.assign(window, {
  Nav,
  Footer
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/Chrome.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/HomeScreen.jsx
try { (() => {
const {
  Button,
  Card,
  Icon,
  ClaimMarquee,
  ClaimPill,
  SatinBlock,
  Badge
} = window.CoolbedsDesignSystem_8ea6cd;
function Hero({
  onNav
}) {
  return /*#__PURE__*/React.createElement("section", {
    style: {
      position: 'relative',
      padding: '0 var(--space-5) var(--space-8)',
      marginTop: 'calc(var(--space-6) * -1)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 'var(--space-7)',
      alignItems: 'center',
      minHeight: 560
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)',
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      font: 'var(--type-display-hero)',
      margin: 0
    }
  }, "Sleep cold,", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 300
    }
  }, "wake composed")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--fs-body-l)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-body)',
      maxWidth: '34ch'
    }
  }, "Satin sheets woven to let heat out. You will notice it on the first night."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-3)',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    onClick: () => onNav('pdp'),
    iconRight: /*#__PURE__*/React.createElement(Icon, {
      name: "arrow-right",
      size: 16
    })
  }, "Shop the set"), /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    variant: "secondary",
    onClick: () => onNav('pdp')
  }, "See the weave")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-4)',
      alignItems: 'center',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      gap: 6,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "truck",
    size: 15
  }), "Free shipping over \xA3120"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      gap: 6,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "rotate-ccw",
    size: 15
  }), "30-night trial"))), /*#__PURE__*/React.createElement(SatinBlock, {
    colorway: "glacier",
    ratio: "5 / 4",
    label: "Hero: bed styled in Glacier, morning light",
    style: {
      boxShadow: 'var(--shadow-lg)'
    }
  })));
}
function Benefits({
  data
}) {
  return /*#__PURE__*/React.createElement("section", {
    style: {
      padding: 'var(--section-y) var(--space-5)',
      background: 'var(--surface-raised)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      display: 'grid',
      gap: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-3)',
      justifyItems: 'center',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(ClaimPill, {
    tone: "outline",
    size: "sm",
    style: {
      letterSpacing: 'var(--tracking-micro)',
      textTransform: 'uppercase',
      fontSize: 'var(--fs-micro)'
    }
  }, "Benefits"), /*#__PURE__*/React.createElement("h2", {
    style: {
      font: 'var(--type-display-section)',
      margin: 0
    }
  }, "Your body runs hot", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 300
    }
  }, "the weave does not"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,1fr)',
      gap: 'var(--space-4)'
    }
  }, data.benefits.map(b => /*#__PURE__*/React.createElement(Card, {
    key: b.title,
    tone: b.tone,
    padding: "lg",
    style: {
      display: 'grid',
      gap: 'var(--space-3)',
      alignContent: 'start',
      minHeight: 210
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 'var(--fs-display-s)',
      fontWeight: 700,
      color: 'inherit',
      margin: 0
    }
  }, b.title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--fs-body-s)',
      lineHeight: 'var(--lh-body)',
      opacity: .82
    }
  }, b.body)))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr',
      gridTemplateRows: 'repeat(2, 176px)',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement(SatinBlock, {
    colorway: "pearl",
    ratio: "auto",
    label: "Detail: hem stitch",
    style: {
      gridRow: 'span 2',
      aspectRatio: 'auto'
    }
  }), /*#__PURE__*/React.createElement(SatinBlock, {
    colorway: "slate",
    ratio: "auto",
    label: "Lifestyle: folded stack",
    style: {
      aspectRatio: 'auto'
    }
  }), /*#__PURE__*/React.createElement(SatinBlock, {
    colorway: "mist",
    ratio: "auto",
    label: "Detail: pillowcase",
    style: {
      aspectRatio: 'auto'
    }
  }), /*#__PURE__*/React.createElement(Card, {
    tone: "ice",
    padding: "md",
    style: {
      gridColumn: 'span 2',
      display: 'grid',
      alignContent: 'center',
      gap: 6
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontSize: 34,
      fontWeight: 700,
      color: 'var(--text-heading)'
    }
  }, "4.8 / 5"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, "from 2,140 nights slept and reviewed")))));
}
function ColorwayStrip({
  data,
  onNav
}) {
  return /*#__PURE__*/React.createElement("section", {
    style: {
      padding: 'var(--section-y) var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      display: 'grid',
      gap: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      gap: 'var(--space-5)',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      font: 'var(--type-display-section)',
      margin: 0
    }
  }, "Four colorways"), /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    onClick: () => onNav('pdp'),
    iconRight: /*#__PURE__*/React.createElement(Icon, {
      name: "arrow-right",
      size: 16
    })
  }, "See all")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4,1fr)',
      gap: 'var(--space-4)'
    }
  }, data.colorways.map(c => /*#__PURE__*/React.createElement("button", {
    key: c.id,
    onClick: () => onNav('pdp', c.id),
    style: {
      border: 'none',
      background: 'transparent',
      padding: 0,
      cursor: 'pointer',
      display: 'grid',
      gap: 'var(--space-3)',
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(SatinBlock, {
    colorway: c.id,
    ratio: "4 / 5"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      fontFamily: 'var(--font-ui)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-body-s)',
      fontWeight: 600,
      color: 'var(--text-heading)'
    }
  }, c.name), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, "\xA3168")))))));
}
function HomeScreen({
  data,
  onNav
}) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Hero, {
    onNav: onNav
  }), /*#__PURE__*/React.createElement(ClaimMarquee, {
    claims: data.claims,
    rows: 2
  }), /*#__PURE__*/React.createElement(Benefits, {
    data: data
  }), /*#__PURE__*/React.createElement(ColorwayStrip, {
    data: data,
    onNav: onNav
  }));
}
Object.assign(window, {
  HomeScreen
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/HomeScreen.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/ProductScreen.jsx
try { (() => {
const {
  Button,
  Card,
  Icon,
  Badge,
  Tabs,
  SwatchPicker,
  SatinBlock,
  Select,
  QuantityStepper,
  Switch,
  Dialog,
  ClaimPill,
  Tooltip
} = window.CoolbedsDesignSystem_8ea6cd;
function ProductScreen({
  data,
  colorway,
  setColorway,
  onAdd
}) {
  const [size, setSize] = React.useState('Queen');
  const [qty, setQty] = React.useState(1);
  const [sub, setSub] = React.useState(false);
  const [tab, setTab] = React.useState('spec');
  const [guide, setGuide] = React.useState(false);
  const p = data.product;
  const price = sub ? Math.round(p.price * .85) : p.price;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-6) var(--space-5) var(--space-9)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1.1fr 1fr',
      gap: 'var(--space-7)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-3)',
      position: 'sticky',
      top: 88
    }
  }, /*#__PURE__*/React.createElement(SatinBlock, {
    colorway: colorway,
    ratio: "4 / 5",
    label: `Hero: ${colorway} set, styled`
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4,1fr)',
      gap: 'var(--space-3)'
    }
  }, data.colorways.map(c => /*#__PURE__*/React.createElement("button", {
    key: c.id,
    onClick: () => setColorway(c.id),
    style: {
      border: 'none',
      padding: 0,
      background: 'transparent',
      cursor: 'pointer',
      borderRadius: 'var(--radius-md)',
      boxShadow: c.id === colorway ? '0 0 0 2px var(--surface-page),0 0 0 3px var(--slate-900)' : 'none'
    }
  }, /*#__PURE__*/React.createElement(SatinBlock, {
    colorway: c.id,
    ratio: "1 / 1"
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-3)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-2)'
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    tone: "success"
  }, "In stock"), /*#__PURE__*/React.createElement(Badge, {
    tone: "ink"
  }, "Bestseller")), /*#__PURE__*/React.createElement("h1", {
    style: {
      font: 'var(--type-display-section)',
      fontSize: 'var(--fs-display-m)',
      margin: 0
    }
  }, p.name), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      color: 'var(--text-muted)',
      fontSize: 'var(--fs-body-s)'
    }
  }, p.subtitle), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-3)',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontSize: 32,
      fontWeight: 700,
      color: 'var(--text-heading)'
    }
  }, "\xA3", price), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-faint)',
      textDecoration: 'line-through'
    }
  }, "\xA3", p.compare), sub && /*#__PURE__*/React.createElement(ClaimPill, {
    tone: "glacier",
    size: "sm"
  }, "Saving 15%"))), /*#__PURE__*/React.createElement(SwatchPicker, {
    options: data.colorways,
    value: colorway,
    onChange: setColorway
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-2)'
    }
  }, /*#__PURE__*/React.createElement(Select, {
    label: "Size",
    options: data.sizes,
    value: size,
    onChange: e => setSize(e.target.value)
  }), /*#__PURE__*/React.createElement("button", {
    onClick: () => setGuide(true),
    style: {
      justifySelf: 'start',
      border: 'none',
      background: 'transparent',
      padding: 0,
      cursor: 'pointer',
      fontFamily: 'var(--font-ui)',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-link)',
      textDecoration: 'underline',
      textUnderlineOffset: 3
    }
  }, "Size guide")), /*#__PURE__*/React.createElement(Card, {
    tone: "ice",
    padding: "sm",
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gap: 2
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-body-s)',
      fontWeight: 600,
      color: 'var(--text-heading)'
    }
  }, "Subscribe & save 15%"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, "A fresh set every 12 months. Cancel anytime.")), /*#__PURE__*/React.createElement(Switch, {
    checked: sub,
    onChange: setSub
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-3)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(QuantityStepper, {
    value: qty,
    onChange: setQty
  }), /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    fullWidth: true,
    onClick: () => onAdd({
      colorway,
      size,
      qty,
      price
    })
  }, "Add to bag \xB7 \xA3", price * qty)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-4)',
      flexWrap: 'wrap',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      gap: 6,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "truck",
    size: 15
  }), "Free over \xA3120"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      gap: 6,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "rotate-ccw",
    size: 15
  }), "30-night returns"), /*#__PURE__*/React.createElement(Tooltip, {
    content: "Certified free of harmful substances"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      gap: 6,
      alignItems: 'center',
      cursor: 'help'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "leaf",
    size: 15
  }), "OEKO-TEX"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement(Tabs, {
    tabs: [{
      id: 'spec',
      label: 'Specs'
    }, {
      id: 'care',
      label: 'Care'
    }, {
      id: 'ship',
      label: 'Shipping'
    }],
    value: tab,
    onChange: setTab
  }), tab === 'spec' && /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gap: 0
    }
  }, p.spec.map(([k, v]) => /*#__PURE__*/React.createElement("div", {
    key: k,
    style: {
      display: 'grid',
      gridTemplateColumns: '150px 1fr',
      gap: 'var(--space-4)',
      padding: 'var(--space-3) 0',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, /*#__PURE__*/React.createElement("dt", {
    style: {
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-muted)',
      fontWeight: 600
    }
  }, k), /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--fs-caption)',
      color: 'var(--text-body)'
    }
  }, v)))), tab === 'care' && /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--fs-body-s)',
      lineHeight: 'var(--lh-body)'
    }
  }, p.care), tab === 'ship' && /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--fs-body-s)',
      lineHeight: 'var(--lh-body)'
    }
  }, p.shipping)))), /*#__PURE__*/React.createElement(Dialog, {
    open: guide,
    title: "Size guide",
    onClose: () => setGuide(false),
    footer: /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: () => setGuide(false)
    }, "Got it")
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse',
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--fs-caption)'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, [['Full', '191 × 203 cm'], ['Queen', '229 × 259 cm'], ['King', '274 × 259 cm'], ['Cal King', '274 × 274 cm']].map(([a, b]) => /*#__PURE__*/React.createElement("tr", {
    key: a
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '8px 0',
      borderBottom: '1px solid var(--border-hairline)',
      fontFamily: 'var(--font-ui)',
      fontWeight: 600
    }
  }, a), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '8px 0',
      borderBottom: '1px solid var(--border-hairline)',
      textAlign: 'right'
    }
  }, b)))))));
}
Object.assign(window, {
  ProductScreen
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/ProductScreen.jsx", error: String((e && e.message) || e) }); }

// ui_kits/storefront/data.js
try { (() => {
window.CB_DATA = {
  claims: ['Cooling weave', 'Mulberry satin', 'OEKO-TEX certified', 'Free returns', '30-night trial', 'No pilling', 'Deep pockets', 'Double-washed soft'],
  colorways: [{
    id: 'pearl',
    name: 'Pearl',
    color: 'var(--way-pearl)'
  }, {
    id: 'glacier',
    name: 'Glacier',
    color: 'var(--way-glacier)'
  }, {
    id: 'slate',
    name: 'Slate',
    color: 'var(--way-slate)'
  }, {
    id: 'mist',
    name: 'Mist',
    color: 'var(--way-mist)'
  }],
  sizes: ['Full', 'Queen', 'King', 'Cal King'],
  product: {
    name: 'The Cool Satin Set',
    subtitle: 'Flat sheet, fitted sheet, two pillowcases',
    price: 168,
    compare: 210,
    spec: [['Fibre', '100% long-staple mulberry satin'], ['Thread count', '400 TC'], ['Weave', 'Open-face cooling satin'], ['Pocket depth', 'Fits mattresses to 40cm'], ['Certification', 'OEKO-TEX Standard 100'], ['Care', 'Machine wash cold, line dry']],
    care: 'Wash cold on a gentle cycle with like colours. Line dry or tumble on low. Skip the fabric softener — it coats the fibre and dulls the sheen.',
    shipping: 'Free standard shipping on orders over £120, arriving in 4–6 days. Express is £8 and arrives in 2. Returns are free within 30 nights, used or not.'
  },
  benefits: [{
    tone: 'ink',
    title: 'Cool to the touch',
    body: 'An open-face weave lets heat leave instead of holding it against you.'
  }, {
    tone: 'slate',
    title: 'Soft on arrival',
    body: 'Double-washed before it ships, so the first night is the good one.'
  }, {
    tone: 'sheen',
    title: 'Stays put',
    body: 'Deep pockets and a bonded elastic hem. No 3am re-tucking.'
  }]
};
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/storefront/data.js", error: String((e && e.message) || e) }); }

__ds_ns.ClaimMarquee = __ds_scope.ClaimMarquee;

__ds_ns.ClaimPill = __ds_scope.ClaimPill;

__ds_ns.SatinBlock = __ds_scope.SatinBlock;

__ds_ns.SwatchPicker = __ds_scope.SwatchPicker;

__ds_ns.Wordmark = __ds_scope.Wordmark;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.Icon = __ds_scope.Icon;

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Tag = __ds_scope.Tag;

__ds_ns.Toast = __ds_scope.Toast;

__ds_ns.Tooltip = __ds_scope.Tooltip;

__ds_ns.Checkbox = __ds_scope.Checkbox;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.QuantityStepper = __ds_scope.QuantityStepper;

__ds_ns.Radio = __ds_scope.Radio;

__ds_ns.Select = __ds_scope.Select;

__ds_ns.Switch = __ds_scope.Switch;

__ds_ns.Dialog = __ds_scope.Dialog;

__ds_ns.IconButton = __ds_scope.IconButton;

__ds_ns.Tabs = __ds_scope.Tabs;

})();
